import React from "react";

const CyberDiplomaPage = () => {
  return <div>CyberDiplomaPage</div>;
};

export default CyberDiplomaPage;
